import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
  color: ${({ theme }) => theme.primaryWhite};
`;

export default Container;
